<!-- 
Timeline of notices for a levy collection provider.
-->
<template>
  <div class="mx-3">
    <v-timeline 
      v-if="lookupsLoaded && notices.length" 
      :dense="dense"
      align-top 
      style="max-width:100%;"
    >
      <template v-for="(notice, index) of notices">
        <notice-timeline-card
          :key="`card-${index}`"
          :notice="notice"
          :description="getNoticeDescription(notice)"
          :index="index"
          :dense="dense"
          @show="show($event)"
          @resend="resend($event)"
        />
      </template>
    </v-timeline>
    <our-empty-tab-message v-else>
      This provider does not have any notices yet.
    </our-empty-tab-message>
    <notice-view-dialog 
      v-model="showNoticeViewDialog" 
      :notice-id="noticeId"
      @resend="showNoticeResendDialog=true"
    />
    <notice-resend-dialog 
      v-model="showNoticeResendDialog" 
      :notice-id="noticeId" 
      :template-type="noticeType"
      :levy-collection-id="levyCollectionId" 
      :provider-id="providerId"
    />
  </div>
</template>

<script>
import * as action from "@/store/notices/action-types";
import NoticeTimelineCard from "@/components/notices/NoticeTimelineCard.vue";
import NoticeViewDialog from "@/components/notices/NoticeViewDialog.vue";
import NoticeResendDialog from "@/components/notices/NoticeResendDialog.vue";
import lookupMixins from "@/mixins/lookup.mixins";
import filterMixins from "@/mixins/filter.mixins";

export default {
  components: { NoticeTimelineCard, NoticeViewDialog, NoticeResendDialog },
  mixins: [lookupMixins, filterMixins],
  props: {
    levyCollectionId: {
      type: Number,
      required: true
    },
    providerId: {
      type: Number,
      required: true
    },
    ascending: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      noticeId: null,
      noticeType: null,
      showNoticeViewDialog: false,
      showNoticeResendDialog: false
    };
  },
  computed: {
    state() {
      return this.$store.state.notices.timeline;
    },
    loaded() {
      return this.state.loaded && this.lookupsLoaded;
    },
    notices() {
      return this.ascending ? this.state.data : Array.from(this.state.data).reverse();
    },
    dense() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  watch: {
    levyCollectionId() {
      this.refresh();
    },
    providerId() {
      this.refresh();
    },
    loaded() {
      this.refresh();
    }
  },
  mounted() {
    this.refresh();
  },
  methods: {
    async refresh() {
      const needsRefresh =
        this.state.levyCollectionId != this.levyCollectionId ||
        this.state.providerId != this.providerId ||
        (!this.state.loaded && !this.state.loading);
      if (needsRefresh) {
        await this.$store.dispatch(action.GET_TIMELINE, {
          levyCollectionId: this.levyCollectionId,
          providerId: this.providerId
        });
      }
    },
    getNoticeType(type) {
      return this.lookups.noticeTypeDescriptions[type];
    },
    getNoticeDescription(notice) {
      let description = this.getNoticeType(notice.type);
      const others = this.notices.filter(n => n.type == notice.type);
      if (others.length > 1) {
        const index = others.indexOf(notice);
        return `${description} #${index + 1}`;
      }
      return description;
    },
    show(notice) {
      this.noticeId = notice.id;
      this.noticeType = notice.type;
      this.showNoticeViewDialog = true;
    },
    resend(notice) {
      this.noticeId = notice.id;
      this.noticeType = notice.type;
      this.showNoticeResendDialog = true;
    },
    getRecipients(values) {
      return values ? values.split(/[\s,;]+/) : null;
    }
  }
};
</script>
